import { useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { usePhone } from "@/hooks/useMedia";

export const MobileFilters = ({ children, testid = "mobile-filters" }) => {
  const phone = usePhone();
  const [open, setOpen] = useState(false);
  if (!phone) return <>{children}</>;
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} className="rounded-full font-bold h-11 bg-[#A6DAFC]" data-testid={`${testid}-open`}>
        <SlidersHorizontal className="h-4 w-4 mr-1.5" />Filtri
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-3xl bg-[#A6DAFC] border-[#5FB3EA] max-h-[85dvh] overflow-y-auto pb-[calc(1.5rem+env(safe-area-inset-bottom))]" data-testid={`${testid}-sheet`} aria-describedby={undefined}>
          <SheetHeader className="text-left"><SheetTitle className="font-display font-black text-[#0A1128]">Filtri</SheetTitle></SheetHeader>
          <div className="mt-4 flex flex-col gap-3 [&_button[role=combobox]]:w-full [&_button[role=combobox]]:h-12 [&_input]:w-full">{children}</div>
          <Button onClick={() => setOpen(false)} className="mt-5 w-full h-12 rounded-full bg-[#0A1128] hover:bg-[#0A1128]/90 font-bold" data-testid={`${testid}-apply`}>Mostra risultati</Button>
        </SheetContent>
      </Sheet>
    </>
  );
};
